// @ts-nocheck

// -----------------------------
// CONFIGURACIÓN LOCAL (fácil de modificar)
const PROGRESSIVE_STEP_CONFIG = {
  SHOP_DOMAIN: 'gf7q0f-ma.myshopify.com',
  TAG: 'progressive-type',
  PRODUCTS_LIMIT: 250,
  PREFERRED_ORDER: ['progresivos-pro', 'progresivos-estandar'],
  MULTI_SELECT: false,
  USE_BASIC_FALLBACK: true,
  // Mostrar imagenes en las cartas de opción si están disponibles
  MOSTRAR_IMAGENES_PRODUCTO: false
};
// -----------------------------

/**
 * Step específico: Sub-tipo de Progresivos
 */
class ProgressiveStep extends LensConfiguratorStep {
  constructor(configurator, options = {}) {
    super(configurator, {
      ...options,
      stepKey: 'progressiveType',
      title: 'Tipo de Progresivos',
      description: 'Selecciona el tipo de cristal progresivo'
    });
    // No cargar automáticamente aquí; init() se llamará cuando el step sea mostrado
  }

  static get STEP_CONFIG() {
    return PROGRESSIVE_STEP_CONFIG;
  }

  async init() {
    if (typeof this.loadConfiguration === 'function') {
      await this.loadConfiguration();
    }
  }

  /**
   * Detecta el dominio de la tienda Shopify de forma robusta
   */
  getShopifyDomain() {
    if (this.configurator && this.configurator.shopDomain) return this.configurator.shopDomain;
    if (window.__AINY_SHOP_DOMAIN) return window.__AINY_SHOP_DOMAIN;
    if (window.Shopify && window.Shopify.shop) return `${window.Shopify.shop}`;
    const shopifyMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopifyMeta && shopifyMeta.content) {
      const match = shopifyMeta.content.match(/([^.]+\.myshopify\.com)/);
      if (match) return match[1];
    }
    return PROGRESSIVE_STEP_CONFIG.SHOP_DOMAIN || 'gf7q0f-ma.myshopify.com';
  }

  getCurrentLocale() {
    if (this.configurator && this.configurator.locale) return this.configurator.locale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    const htmlLang = document.documentElement && document.documentElement.lang;
    if (htmlLang) return htmlLang.split('-')[0];
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale && ogLocale.content) return ogLocale.content;
    return null;
  }

  buildShopifyProductsUrl(query) {
    const shopDomain = this.getShopifyDomain();
    const locale = this.getCurrentLocale();
    let url = `https://${shopDomain}/products.json?limit=${PROGRESSIVE_STEP_CONFIG.PRODUCTS_LIMIT}`;
    if (query && typeof query === 'string') {
      const q = query.replace(/^\?/, '');
      if (q) url += `&${q}`;
    }
    if (locale) url += `&locale=${encodeURIComponent(locale)}`;
    return url;
  }

  async loadConfiguration() {
    if (!this.configurator.config) this.configurator.config = {};
    this.configurator.config.progressiveTypes = await this.loadProgressiveTypesFromShopify();
    try { this.render(); } catch (e) { console.warn('⚠️ Error al re-renderizar ProgressiveStep:', e); }
  }

  async loadProgressiveTypesFromShopify() {
    try {
      let products = [];
      if (window.LensStepUtils && typeof window.LensStepUtils.fetchProductsByTag === 'function') {
        products = await window.LensStepUtils.fetchProductsByTag(this.configurator, PROGRESSIVE_STEP_CONFIG.TAG, PROGRESSIVE_STEP_CONFIG.PRODUCTS_LIMIT);
        console.log('👓 Productos (via LensStepUtils) con tag lens-progressive:', products);
      } else {
        const url = this.buildShopifyProductsUrl(`?q=tag:${PROGRESSIVE_STEP_CONFIG.TAG}`);
        console.log('🔍 (fallback) Consultando productos de Shopify:', url);
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        const d = await res.json();
        const allProducts = d.products || [];
        products = allProducts.filter(p => p.tags && p.tags.includes(PROGRESSIVE_STEP_CONFIG.TAG));
        console.log('👓 (fallback) Productos con tag lens-progressive:', products);
      }

      if (!products || products.length === 0) {
        console.warn('⚠️ No se encontraron productos con tag "lens-progressive"');
        return this.getBasicProgressiveTypes();
      }

      const progressiveTypes = {};
      products.forEach(product => {
        const key = this.mapProductToProgressiveKey(product);
        if (key) {
          const price = (window.LensStepUtils && typeof window.LensStepUtils.parsePrice === 'function')
            ? window.LensStepUtils.parsePrice(product)
            : this.parsePrice(product);

          progressiveTypes[key] = {
            name: product.title,
            description: this.extractProductDescription(product),
            price: price,
            productId: product.id,
            handle: product.handle,
            image: product.images && product.images.length > 0 ? product.images[0].src : null,
            variants: product.variants
          };
          console.log(`✅ Mapeado progresivo: ${product.title} -> ${key}`);
        } else {
          console.warn(`❌ No se pudo mapear: ${product.title} (handle: ${product.handle})`);
        }
      });

      if (Object.keys(progressiveTypes).length === 0) {
        console.warn('⚠️ No se pudieron mapear productos a tipos progresivos');
        return this.getBasicProgressiveTypes();
      }

      console.log('✅ Tipos progresivos cargados desde Shopify:', progressiveTypes);
      return progressiveTypes;
    } catch (err) {
      console.error('❌ Error cargando tipos progresivos desde Shopify:', err);
      return this.getBasicProgressiveTypes();
    }
  }

  parsePrice(product) {
    if (!product.variants || product.variants.length === 0) return 0;
    const variant = product.variants[0];
    if (variant.price) return parseFloat(variant.price);
    return 0;
  }

  mapProductToProgressiveKey(product) {
    const handle = (product && product.handle) ? String(product.handle).toLowerCase().trim() : '';

    // Mapeo estricto por handle
    const exact = {
      'progresivos-estandar': 'standard',
      'progresivos-premium': 'premium',
      'progresivos-digital': 'digital',
      'progresivos-personalizados': 'custom',
      'progresivos-pro': 'premium',
      'progresivos-estándar': 'standard'
    };

    if (exact[handle]) return exact[handle];

    // Patrones comunes: sufijos o prefijos
    if (/^progresivos?-estandar|estandar$/.test(handle)) return 'standard';
    if (/^progresivos?-premium|progresivos?-pro|(-|_)pro$/.test(handle)) return 'premium';
    if (/digital/.test(handle)) return 'digital';
    if (/personaliz|personalizados/.test(handle)) return 'custom';

    console.warn('⚠️ No se pudo mapear el producto progresivo por handle:', product.handle);
    return null;
  }

  extractProductDescription(product) {
    if (product.body_html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = product.body_html;
      const text = tempDiv.textContent || tempDiv.innerText || '';
      const clean = text.replace(/\s+/g, ' ').trim();
      return clean.length > 150 ? clean.substring(0, 150) + '...' : clean;
    }
    return 'Sin descripción disponible';
  }

  getBasicProgressiveTypes() {
    console.warn('⚠️ Usando configuración básica por defecto para progresivos');
    return {
      standard: { name: 'Estándar', price: 0, description: 'Progresivos estándar', isDefault: true },
      premium: { name: 'Premium', price: 35, description: 'Progresivos premium', isDefault: false },
      digital: { name: 'Digital', price: 50, description: 'Progresivos digitales', isDefault: false },
      custom: { name: 'Personalizados', price: 75, description: 'Progresivos personalizados', isDefault: false }
    };
  }

  shouldSkip() {
    return this.configurator.configuration.lensType !== 'progressive';
  }

  render() {
    const container = document.getElementById('progressive-sub-options');
    if (!container) {
      console.error('❌ No se encontró el contenedor progressive-sub-options');
      return;
    }

    if (!this.configurator.config || !this.configurator.config.progressiveTypes || Object.keys(this.configurator.config.progressiveTypes).length === 0) {
      console.warn('⚠️ Tipos progresivos no cargados dinámicamente — usando configuración básica por defecto.');
      this.configurator.config = this.configurator.config || {};
      this.configurator.config.progressiveTypes = this.getBasicProgressiveTypes();
    }

    container.innerHTML = '';

    const preferredOrder = PROGRESSIVE_STEP_CONFIG.PREFERRED_ORDER || ['standard', 'premium', 'digital', 'custom'];
    const map = this.configurator.config.progressiveTypes || {};
    const isMultiple = Boolean(PROGRESSIVE_STEP_CONFIG.MULTI_SELECT);
    container.dataset.multiple = isMultiple.toString();

    preferredOrder.forEach(key => {
      if (map[key]) {
        const card = this.createOptionCard(key, map[key], 'progressiveType', isMultiple);
        container.appendChild(card);
      }
    });

    Object.entries(map).forEach(([key, val]) => {
      if (!preferredOrder.includes(key)) {
        const card = this.createOptionCard(key, val, 'progressiveType', isMultiple);
        container.appendChild(card);
      }
    });

    console.log('🎨 Renderizados tipos progresivos:', this.configurator.config.progressiveTypes);
  }
}

// Hacer disponible globalmente
window.ProgressiveStep = ProgressiveStep;
